module.exports = __webpack_public_path__ + "static/winter-seizoenen-64399a9247be33957c3c34da121b8faf.jpg";